import { type JSX } from 'react';

import { createFileRoute } from '@tanstack/react-router';

import { MyThemesPage } from '@/features/themes/pages/MyThemesPage';

export const Route = createFileRoute('/banco-de-temas/meus-temas')({
  component: MeusTemasTab,
});

function MeusTemasTab(): JSX.Element {
  return <MyThemesPage />;
}
